export default {
  // BTC余额
  btcBalance: "BTC余额",
  updated: "更新",

  // 交易概况
  transactionOverview: "交易概况",
  cumulativeInOutAmount: "累计转入&转出数量",
  inOutTransactions: "转入&转出笔数",
  avgInOutAmount: "平均转入&平均数量",
  firstTransactionTime: "首次交易时间",
};
